module.exports = __webpack_public_path__ + "static/ivl-logo-d854c191ff017404cdcae3c412e0f8be.svg";